<template>
  <div>
    <table-component
      ref="participantsTable"
      :data="fetchParticipants"
      :show-caption="false"
      class="datatable"
      :show-filter="true">
      <table-column show="id" label="Id" :hidden="true"></table-column>

      <table-column
        show="username"
        :label="$t('health.challenge.participant.username')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

      <table-column
        show="email"
        :label="$t('health.challenge.participant.email')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

      <table-column
        show="currentStreak"
        :formatter="valueFormatter"
        :label="$t('health.challenge.participant.currentStreak')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

      <table-column
        show="maxValue"
        :formatter="valueFormatter"
        :label="$t('health.challenge.participant.maxStreak')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

      <table-column
        show="maxLevel"
        :label="$t('health.challenge.participant.maxLevel')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

      <table-column
        show="createdAt"
        :formatter="dateFormatter"
        :label="$t('health.challenge.participant.joinedAt')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

      <table-column
        show="lastUpdate"
        :formatter="dateTimeFormatter"
        :label="$t('health.challenge.participant.lastUpdate')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>

    </table-component>
  </div>
</template>

<script>

import TableComponent from '@/components/shared/table/components/TableComponent';
import TableRow from '@/components/shared/table/components/TableRow';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
export default {
  components: {
    TableComponent,
    TableRow,
    TableColumn
  },
  props: {
    participants: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      /* Table */
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  watch: {
    getParticipants: {
      handler: function () {
        this.$refs.participantsTable.refresh();
      }
    }
  },
  computed: {
    getParticipants () {
      return this.participants;
    }
  },
  methods: {
    fetchParticipants ({page, filter, sort}) {
      page = page === null || isNaN(page) ? 1 : page;
      const tablePage = pagination.createPage(
        this.getParticipants,
        this.tableState,
        ['username'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    valueFormatter (value) {
      return value != null ? value : 0;
    },
    dateFormatter (timestamp) {
      if (timestamp === null) return '-';
      const date = new Date(timestamp);
      return date.toLocaleDateString('en-GB');
    },
    dateTimeFormatter (timestamp) {
      if (timestamp === null) return '-';
      const date = new Date(timestamp);
      return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleString('en-GB', {hour: '2-digit', minute: '2-digit'});
    }
  }
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/participantsTables/StreakChallengeParticipantsTable.vue